<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row dense align="center" justify="center">
            <v-col cols="12" sm="3" md="3">
                <v-autocomplete dense outlined rounded item-value="id" item-text="ay" :items="ay_list" v-model="acay"
                    label="Admission Year" @change="fetchForm()"></v-autocomplete>
            </v-col>
        </v-row>
        <div v-if="Hide_Application_Form_For_Parents === true">
            <!-- Application Form Table -->
            <v-data-table :headers="show_form_headers" :items="show_only_view_form_list" class="elevation-1 mytable"
                dense :search="search1">
                <template v-slot:[`item.admission_form_id`]="{ item }">
                    <div v-if="item.admission_form_id != null">
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" @click="viewForm(item)">mdi-eye</v-icon>
                            </template>
                            <span>View</span>
                        </v-tooltip>
                    </div>
                    <div v-else>--</div>
                </template>
            </v-data-table>
        </div>
        <div id="form-list" v-if="to_show == 'Form-List'">
            <v-app id="inspire">
                <v-card class="box">
                    <v-toolbar dense flat class="toolbar">
                        <v-toolbar-title> Filled Admission Form List </v-toolbar-title>

                        <!-- <v-spacer></v-spacer> -->

                        <!-- <v-row dense align="center" justify="center">
            <v-col cols="12" sm="4" md="4">
              <b>
                <span class="ay-main"> Academic Year {{ cay.ay }} </span></b
              >
            </v-col>
          </v-row> -->
                    </v-toolbar>

                    <v-toolbar dense flat>
                        <!-- <v-toolbar-title>
                      Filled Admission Form List
                      </v-toolbar-title> -->
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line
                            hide-details></v-text-field>
                        <span style="width: 20px;"></span>
                        <div id="newformlink">
                            <v-btn class="button" @click="openDialog()" v-if="!allotmentApplicable">New Form</v-btn>
                        </div>
                    </v-toolbar>

                    <!-- <v-row justify="center" dense class="pb-0"
          >Academic Year {{ cay.ay }}</v-row
        > -->
                    <v-data-table v-if="form_list != ''" :headers="headers" :items="form_list"
                        class="elevation-1 mytable" dense :search="search">
                        <template v-slot:[`item.applicationstatus`]="{ item }">
                            <strong>{{ item.applicationstatus }}</strong>
                        </template>

                        <template v-slot:[`item.action`]="{ item }">
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <v-avatar style size="25" class="edit-avatar">
                                        <v-icon class="edit-v-icon mr-2" @click="loadForm(item)" :title="item.applicationstatus == 'Initiated'
                                            ? 'Edit'
                                            : 'Cannot edit after submittion'
                                            " :disabled="item.applicationstatus != 'Initiated'" style>
                                            edit
                                        </v-icon>
                                    </v-avatar>
                                </template>
                                <span>edit</span>
                            </v-tooltip>
                        </template>

                        <template v-slot:[`item.view`]="{ item }">
                            <!-- <center v-if="tenant != 'eps' && tenant != 'sbpps'"> -->
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <v-icon :disabled="!item.is_receipt_generated && Hide_Application_Form_If_Receipt_Not_Generated" @click="viewForm(item)" style> mdi-eye </v-icon>
                                </template>
                                <span>View</span>
                            </v-tooltip>
                            <!-- </center>
                             <center v-else>
                                --
                             </center> -->
                        </template>

                        <template v-slot:[`item.can_pay_form_fees`]="{ item }">
                            <center>
                                <span v-if="item.can_pay_form_fees == true">
                                    <v-btn v-if="item.fees_paid != true && item.applicationstatus == 'Submitted' && qrConfig && qrConfig.is_application_payment_via_qr"
                                        rounded small color="primary" @click="payFormFeesByQRDialog = true">Pay By QR</v-btn>
                                    <v-btn v-else-if="item.fees_paid != true && item.applicationstatus == 'Submitted'"
                                        rounded small color="primary" @click="payFormFeesPage()">Pay</v-btn>
                                    <v-btn v-else-if="item.fees_paid == true" @click="viewReceipt(item)" rounded small
                                        color="primary">Receipt</v-btn>
                                    <span v-else>--</span>
                                </span>
                                <span v-else> -- </span>
                            </center>
                        </template>
                        <template v-slot:[`item.can_pay_elective_fees`]="{ item }">
                            <center>
                                <!-- <v-btn v-if="item.regular_fees_paid == true" rounded small @click="payElectiveFees()"
                                        color="primary">Pay Elective Fees & Preference</v-btn> -->
                                <span v-if="item.can_pay_elective_fees == true">
                                    <v-btn v-if="item.regular_fees_paid == true" @click="payElectiveFees()" rounded small
                                        color="primary">Pay Elective Fees & Preference</v-btn>
                                    <span v-else>--</span>
                                </span>
                                <span v-else> -- </span>
                            </center>
                        </template>
                        <template v-slot:[`item.can_pay_form_fees`]="{ item }">
                            <center>
                                <span v-if="item.can_pay_form_fees == true">
                                    <v-btn v-if="item.fees_paid != true && item.applicationstatus == 'Submitted' && qrConfig && qrConfig.is_application_payment_via_qr"
                                        rounded small color="primary" @click="payFormFeesByQRDialog = true">Pay By QR</v-btn>
                                    <v-btn v-else-if="item.fees_paid != true && item.applicationstatus == 'Submitted'"
                                        rounded small color="primary" @click="payFormFeesPage()">Pay</v-btn>
                                    <v-btn v-else-if="item.fees_paid == true" @click="viewReceipt(item)" rounded small
                                        color="primary">Receipt</v-btn>
                                    <span v-else>--</span>
                                </span>
                                <span v-else> -- </span>
                            </center>
                        </template>

                        <template v-slot:[`item.pay_fee`]="{ item }">
                            <center>
                                <span v-if="item.can_pay_inst_fees == true">
                                    <v-btn small rounded color="warning"
                                        @click="payInstFeesPage(item.admission_form_id)">Pay</v-btn>
                                </span>
                                <span v-else> -- </span>
                            </center>
                        </template>

                        <template v-slot:item.form_progress="{ item }">
                            <v-progress-circular :indeterminate="indeterminate" :rotate="rotate" size="40"
                                :value="item.form_progress" width="4" :color="item.form_progress >= 0 && item.form_progress < 70
                                    ? 'red'
                                    : 'success'
                                    ">
                                {{ item.form_progress }}
                            </v-progress-circular>
                        </template>
                        <template v-slot:item.secondary_email="{ item }">
                            <div class="d-flex align-center" v-if="item.secondary_email != null">
                                <span>{{ item.secondary_email }}</span>
                            </div>
                            <div class="d-flex align-center" v-else>
                                <v-btn fab dark x-small class="quick-link-add-btn"
                                    @click="open_secondary_email_dialog(item)" style="background-color: #4caf50;">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>

                            </div>
                        </template>
                    </v-data-table>
                    <center>
                        <span v-if="tenant == 'sbpps' || tenant == 'eps'"> Note: After 100% progress, kindly pay form
                            fees to complete the form submission process</span>
                        <span v-else> Note: If Status is Initiated and Progress is 100%, please submit the form to
                            change the status into Submited </span>
                    </center>

                    <hr />
                    <br />


                </v-card>
                <!-- {{ is_receipt_generated }} -->
                <!-- <v-card class="box" v-if="defaultValues!=null && is_receipt_generated">
          <v-col cols="12" sm="12" md="12" class="mr-5 pr-5"> <div  v-html="defaultValues"></div> </v-col>
        </v-card> -->
                <!-- <v-card class="box" v-if="is_receipt_generated">
            <v-col cols="12" sm="12" md="12" class="mr-5 pr-5">
                <h2>Thank you for registering with S.B. Patil Public School for {{ grade }}</h2>
                
                <p>Photocopies of the below-mentioned documents need to be carried along with the printout of the Admission Form, Health Form, Transport Form, and Canteen Form on the day of Interaction. Failing this, the admission process for your ward may get delayed/affected.</p>
                
                <ul>
                <li><em>Passport size photograph each of mother, father, child, and guardian (if applicable).</em></li>
                <li><em>Photocopy of the child’s birth certificate, having the child's name on the same.</em></li>
                <li><em>Photocopy of current address proof (Aadhar card, electricity bill, LPG receipt, bank passbook, registered rent agreement, etc.).</em></li>
                <li><em>Photocopy of the child’s Aadhar card.</em></li>
                </ul>
                
                <p><strong>Admission Test Schedule is as follows:</strong></p>
                
                <table style="border: 1px solid black; border-collapse: collapse;">
                <thead>
                    <tr>
                    <th style="border: 1px solid black;padding: 5px">Sr.No.</th>
                    <th style="border: 1px solid black;padding: 5px">Form No.</th>
                    <th style="border: 1px solid black;padding: 5px">Date</th>
                    <th style="border: 1px solid black;padding: 5px">Time</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(schedule, index) in admissionSchedule" :key="index" style="text-align: center;">
                    <td style="border: 1px solid black;padding: 5px">{{ index + 1 }}.</td>
                    <td style="border: 1px solid black;padding: 5px">{{ schedule.formNo }}</td>
                    <td style="border: 1px solid black;padding: 5px">{{ schedule.date }}</td>
                    <td style="border: 1px solid black;padding: 5px">{{ schedule.time }}</td>
                    </tr>
                </tbody>
                </table>
            </v-col>
        </v-card> -->
                <v-card class="box" v-for="(form, index) in form_list" :key="index" v-if="form.is_receipt_generated">
                    <v-col cols="12" sm="12" md="12" class="mr-5 pr-5">
                        <!-- Dynamic Content for Each Form -->
                        <div v-if="form.admission_schedule"
                            v-html="form.admission_schedule.replace('{{ grade }}', form.standard)"></div>
                    </v-col>
                </v-card>




                <v-expansion-panels v-if="form_list != '' && tenant == 'eps' || tenant == 'sbpps'" focusable
                    class="box">
                    <v-expansion-panel>
                        <v-expansion-panel-header class="toolbar">
                            <center><strong>Payment History</strong> <br /></center>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-col cols="12" sm="12" md="12">
                                <parent-fee-history></parent-fee-history>
                            </v-col>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <!-- <parent-fee-history v-if="form_list!=''&& tenant == 'eps' || tenant == 'sbpps'"></parent-fee-history> -->
                <!-- <v-card class="box" v-if="admission_quota_list!='' && tenant == 'eps' || tenant == 'sbpps'">
                        <v-data-table :headers="headers_quota" :items="admission_quota_list" dense>
                            <template v-slot:top>
                                <v-toolbar flat class="toolbar">
                                    <v-toolbar-title>Standard Quota List</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </v-card> -->

            </v-app>
        </div>

        <div id="Show-form" v-if="to_show == 'Show-Form'">
            <v-card class="box" color="admission-color">
                <!-- <v-row>
                  <v-btn  class="button mb-2" v-if="reload_comp" @click="init_or_reload()"> <v-icon left>mdi-arrow-left-bold-circle-outline</v-icon> Back to Form List</v-btn>
              </v-row> -->
                <v-toolbar flat dense class="toolbar">
                    <v-btn rounded small class="mt-1 footer-btn" color="#fff" v-if="reload_comp"
                        @click="getFormsByAY()">
                        <v-icon left>mdi-arrow-left-bold-circle-outline</v-icon>
                        <span class="back-form">Back to Form List</span>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <!-- <v-toolbar-title class="justify-center"> -->
                    <span class="add-form"> Admission Form #{{ display_admission_form_no }}</span>

                    <!-- </v-toolbar-title> -->
                    <v-spacer></v-spacer>
                    <span class="add-form"> Admission Year {{ cay.ay }}</span>
                </v-toolbar>
                <br />
                <!-- <marquee class="marq" bgcolor = "red" direction = "left" loop="" >
        <div class="geek2">Please remember your form number <strong>{{ admission_form_no }}</strong></div>
    </marquee> -->
                <span class="flash">
                    <strong>
                        <center>Please remember your form number is : <strong>{{ display_admission_form_no }}</strong></center>
                    </strong>
                </span>

                <center>
                    <v-row justify="center">
                        <v-col v-if="admission_instruction != null && tenant != 'uwws'" style="">
                            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="admission-inst" color="primary" dark v-bind="attrs" v-on="on">
                                        Admission Form Instructions
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-toolbar dark color="primary">
                                        <a class="admission-inst" style="" v-if="admission_instruction_pdf != null"
                                            target="_blank" :href="admission_instruction_pdf">
                                            <v-icon>mdi-file-download-outline</v-icon>&nbsp;Admission Form Instructions
                                        </a>
                                        <v-spacer></v-spacer>
                                        <v-toolbar-items>
                                            <v-btn dark text @click="dialog = false"> Close </v-btn>
                                        </v-toolbar-items>
                                    </v-toolbar>
                                    <v-card-text>
                                        <br />
                                        <div v-html="admission_instruction.admission_instructions_html_code
                                            "></div>
                                        <br />
                                        <v-divider></v-divider>
                                        <br />
                                        <div v-html="admission_instruction.admission_checklist_html_code
                                            "></div>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                        </v-col>

                        <!-- <v-col v-if="tenant != 'eps' && tenant != 'sbpps'"> -->
                        <v-col v-if="tenant != 'desschool'">
                            <v-btn color="info" @click="viewForm(null)">View Filled Form</v-btn>
                        </v-col>
                         <v-col>
                            
                            <v-btn color="info" @click="viewrequiredfields()">View Required fields</v-btn>
                        </v-col>
                    </v-row>
                </center>
                <br />
               
                <div class="d-flex">
                    <v-progress-linear class="toolbar" color="green" height="30" :value="form_progress" reactive>
                        <template v-slot="{ value }">
                            <strong>Status {{ Math.ceil(form_progress) }}%</strong>
                        </template>
                    </v-progress-linear>

                    <v-btn small color="warning" dark v-if="Math.ceil(form_progress) == 100 || enable_submit"
                        @click="submitApplication()">
                        Submit
                    </v-btn>
                    <v-btn small v-else disabled title="complete admmision form" @click="submitApplication()">
                        Submit
                    </v-btn>
                    
                </div>
               
                <center>
                    <span>Please <strong>SUBMIT</strong> once Status is 100%</span> <br />
                    <span>Best viewed in google <strong>chrome</strong></span>
                </center>

                <br />

                <!-- <v-tabs v-model="tab" background-color="transparent" color="admission-color" grow show-arrows slider-color="primary" :icons-and-text="true" active-class="active-class"> -->
                <span v-if="tenant == 'sbpps' || tenant == 'eps'">
                    <v-tabs v-model="tab" background-color="#4b89ac" slider-color="#C89933" optional
                        icons-and-text="true" centered class="custom-tabs" active-class="active-tab">
                        <v-tab class="normalize font-weight-bold" v-for="item in filteredTabs" :key="item.tabname"
                            style="text-transform: capitalize;">
                            <template>
                                {{ item.tabname }}
                            </template>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in filteredTabs" :key="item.tabname">
                            <v-card flat color="admission-color">
                                <v-card-text>
                                    <component @standardUpdated="refreshStandard" v-bind:is="item.component" :key="tab">
                                    </component>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </span>
                <span v-else-if="tenant == 'sanjivani' || tenant == 'eps'">
                    <v-tabs v-model="tab" background-color="#4b89ac" slider-color="#C89933" optional
                        icons-and-text="true" centered active-class="active">
                        <v-tab class="normalize font-weight-bold" v-for="item in items_sanjivani" :key="item.tabname"
                            style="text-transform: capitalize;">
                            <template>
                                {{ item.tabname }}
                            </template>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in items_sanjivani" :key="item.tabname">
                            <v-card flat color="admission-color">
                                <v-card-text>
                                    <component v-bind:is="item.component"></component>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </span>
                <span v-else-if="tenant == 'zeal'">
                    <v-tabs v-model="tab" background-color="#4b89ac" slider-color="#C89933" optional
                                            icons-and-text="true" centered active-class="active">
                        <v-tab
                        class="normalize font-weight-bold"
                        v-for="item in items_zeal"
                        :key="item.tabname"
                        style="text-transform: capitalize;"
                        >
                        {{ item.tabname }}
                        <v-icon>{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in items_zeal" :key="item.tabname">
                        <v-card flat color="admission-color">
                            <v-card-text>
                            <component :is="item.component"></component>
                            </v-card-text>
                        </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </span>

                <span v-else-if="tenant == 'desschool' && allotmentApplicable">
                    <v-tabs v-model="tab" background-color="#4b89ac" slider-color="#C89933" optional
                                            icons-and-text="true" centered active-class="active">
                        <v-tab
                        class="normalize font-weight-bold"
                        v-for="item in items_desschool_allotment"
                        :key="item.tabname"
                        style="text-transform: capitalize;"
                        v-if="!(item.tabname == '7.Subject Registration' && Subject_Registration_Tab)"
                        >
                        {{ item.tabname }}
                        <v-icon>{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in items_desschool_allotment" :key="item.tabname" v-if="!(item.tabname == '7.Subject Registration' && Subject_Registration_Tab)">
                        <v-card flat color="admission-color">
                            <v-card-text>
                            <component :is="item.component"></component>
                            </v-card-text>
                        </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </span>

                <span v-else>
                    <v-tabs v-model="tab" background-color="#4b89ac" slider-color="#C89933" optional
                        icons-and-text="true" centered active-class="active">
                        <v-tab class="normalize font-weight-bold" v-for="item in items" :key="item.tabname"
                            style="text-transform: capitalize;">
                            <template v-if="tenant == 'uwws' && item.tabname == 'Contact Details'">Emergency </template>
                            <template v-if="tenant == 'uwws' && item.tabname == '2.Parent Details'">2.Family Details
                            </template>
                            <template v-else-if="tenant == 'uwws' && item.tabname == '3.Contact Details'">3.Guardian
                                Details </template>
                            <template v-else>
                                {{ item.tabname }}
                            </template>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in items" :key="item.tabname">
                            <v-card flat color="admission-color">
                                <v-card-text>
                                    <component v-bind:is="item.component"></component>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </span>
            </v-card>
        </div>
        <v-dialog v-model="admission_personal_email_dialog" width="700px">

            <v-card>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Generate New Form</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row class="justify-center" v-if="tenant == 'desschool'">
                    <v-col cols="12" sm="6" md="6">
                        <span class="pl-1 pb-2" style="font-size: 14px;">
                            <b>Please Enter Contact Number :</b>
                        </span>
                        <v-icon class="pl-1 pb-2" color="error">*</v-icon>

                        <v-text-field v-model="admission_personal_contact_number" label="Contact" single-line
                            :readonly="usertype === 'Parent'" :filled="usertype === 'Parent'" :rules="mobileRules"
                            rounded outlined dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <template v-else>
                <v-row class="justify-center">
                    <v-col cols="12" sm="6" md="6">
                        <span class="pl-1 pb-2" style="font-size: 14px;">
                            <b>Please Enter Email :</b>
                        </span>
                        <v-icon class="pl-1 pb-2" color="error">*</v-icon>

                        <v-text-field v-model="admission_personal_email" label="Email" single-line
                            :readonly="usertype === 'Parent'" :filled="usertype === 'Parent'" :rules="emailRules"
                            rounded outlined dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="justify-center">
                    <v-col cols="12" sm="6" md="6">
                        <span class="pl-1 pb-2" style="font-size: 14px;">
                            <b>Please Enter Secondary Email (optional) :</b>
                        </span>


                        <v-text-field v-model="admission_secondary_email" label="secondary Email" single-line
                             rounded outlined dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                </template>
                <v-card-text>
                    <v-row class="justify-center">
                        <v-btn dark text @click="checkAndSavePersonalEmail()" class="button" color="primary"> Save
                        </v-btn>
                        <v-btn dark text @click="admission_personal_email_dialog = false" class="button"
                            color="primary"> Close
                        </v-btn>
                    </v-row>

                </v-card-text>

            </v-card>
        </v-dialog>
        <v-dialog v-model="admission_secondary_email_dialog" width="700px">

            <v-card>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Add Secondary Email</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-row class="justify-center">
                    <v-col cols="12" sm="6" md="6">
                        <span class="pl-1 pb-2" style="font-size: 14px;">
                            <b>Please Enter Secondary Email :</b>
                        </span>
                        <br>
                        <br>


                        <v-text-field v-model="generate_only_secondary_email" label="Secondary Email" single-line
                            :rules="emailRules" rounded outlined dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-card-text>
                    <v-row class="justify-center">
                        <v-btn dark text @click="saveOnlySecondaryEmail()"  :loading="loadingforgenerateonlysecondaryemail" class="button" color="primary"> Save
                        </v-btn>
                        <v-btn dark text @click="admission_secondary_email_dialog = false" class="button"
                            color="primary"> Close
                        </v-btn>
                    </v-row>

                </v-card-text>

            </v-card>
        </v-dialog>
        <v-dialog v-model="application_form_requied_dialog" width="600px">

            <v-card>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Requied Fields</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-row class="justify-center">
                 
                  <v-data-table v-if="application_form_requied != ''" :headers="requied_headers" :items="application_form_requied"
                        class="elevation-1 mytable mt-5" dense  style="width: 80%;"></v-data-table>
                </v-row>
                <v-card-text>
                    <v-row class="justify-center">
                        <!-- <v-btn dark text @click="saveOnlySecondaryEmail()"  :loading="loadingforgenerateonlysecondaryemail" class="button" color="primary"> Save
                        </v-btn> -->
                        <v-btn dark text @click="application_form_requied_dialog = false" class="button"
                            color="primary"> Close
                        </v-btn>
                    </v-row>

                </v-card-text>

            </v-card>
        </v-dialog>

        <v-dialog v-model="payFormFeesByQRDialog" max-width="1000">
            <v-card class="rounded-xl elevation-10">

                <!-- Header -->
                <v-toolbar color="primary" dark flat>
                <v-icon class="mr-2">mdi-qrcode-scan</v-icon>
                <v-toolbar-title class="font-weight-medium">
                    Pay Form Fees
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="payFormFeesByQRDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </v-toolbar>

                <!-- Content -->
                <v-card-text class="text-center pa-6">

                <!-- Amount -->
                <v-chip
                    v-if="app_form_fee_master"
                    color="green"
                    text-color="white"
                    large
                    class="mb-4"
                >
                    <v-icon left>mdi-currency-inr</v-icon>
                    {{ app_form_fee_master.amount }} /-
                </v-chip>

                <!-- QR Code -->
                <v-card
                    v-if="qrConfig && qrConfig.qrCode"
                    class="pa-4 mx-auto elevation-4"
                    width="220"
                    outlined
                >
                    <v-img
                    :src="qrConfig.qrCode"
                    width="180"
                    height="180"
                    contain
                    class="mx-auto"
                    ></v-img>

                    <div class="subtitle-1 mt-2">
            Scan to Pay
            </div>
      </v-card>

      <!-- Instructions -->
      <v-alert
        v-if="qrConfig && qrConfig.instructions"
        dense
        outlined
        class="mt-5 text-left"
      >
        <div v-html="qrConfig.instructions"></div>
      </v-alert>

    </v-card-text>

  </v-card>
</v-dialog>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Profile from "./Profile";
import Contact from "./Contact";
import ContactDetailsSBPPS from "./ContactDetailsSBPPS";
import AddressDetails from "./AddressDetails";
import AddressDetailsSBPPS from "./AddressDetailsSBPPS";
import FamilyDetails from "./FamilyDetails";
import LastSchoolAttended from "./LastSchoolAttended";
import UploadDocuments from "./UploadDocuments";
import ViewForm from "./ViewForm";
import ParentFeeHistory from "../AccountingAndFees/Parent/ParentFeeHistory";
import StudentMedicalDetails from "./StudentMedicalDetails";
import FamilyDetailsSbpps from "./FamilyDetailsSbpps";
import TransportDetails from "./TransportDetails";
import CanteenDetails from "./CanteenDetails";
import SubjectRegistrationDetails from "./SubjectRegistrationDetails";
import SubjectRegistrationDetailsSBPPS from "./SubjectRegistrationDetailsSBPPS";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import { readonly } from "vue";
import SubjectRegistrationDES from "./SubjectRegistrationDES.vue";

export default {
    components: {
        "comp-profile": Profile,
        "comp-contact": Contact,
        "comp-contact-details-sbpps": ContactDetailsSBPPS,
        "comp-address-details": AddressDetails,
        "comp-address-details-sbpps": AddressDetailsSBPPS,
        "comp-family-details": FamilyDetails,
        "comp-family-details-sbpps": FamilyDetailsSbpps,
        "comp-last-school-attended": LastSchoolAttended,
        "comp-upload-documents": UploadDocuments,
        "comp-view-form": ViewForm,
        "parent-fee-history": ParentFeeHistory,
        "comp-stud-medical-details": StudentMedicalDetails,
        "comp-stud-transport-details": TransportDetails,
        "comp-stud-canteen-details": CanteenDetails,
        "subject-registration-details": SubjectRegistrationDetails,
        "subject-registration-details-sbpps": SubjectRegistrationDetailsSBPPS,
        "subject-registration-details-desschool": SubjectRegistrationDES,
        Breadcrumbs
    },
    data() {
        return {
            uid: "",
            usertype: "",
            standardName: "",
            grade: "Grade III",  // You can update this dynamically
            admissionSchedule: [
                { formNo: "672 to 721", date: "Thursday, 16th January 2025", time: "10.00 am to 11.00 am" },
                { formNo: "722 to 771", date: "Thursday, 16th January 2025", time: "11.30 am to 12.30 pm" },
                { formNo: "772 to 821", date: "Thursday, 16th January 2025", time: "1.00 pm to 2.00 pm" },
                { formNo: "822 to 871", date: "Thursday, 16th January 2025", time: "2.30 pm to 3.30 pm" },
            ],
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_list: [],
            acay: "",
            Hide_Application_Form_For_Parents: false,
            Hide_Application_Form_If_Receipt_Not_Generated: false,
            hide_component:false,
            tenant: "wws",
            cay: null,
            tab: 0,
            overlay: false,
            // extraBreadcrumbItems: [
            // ],
            breadcrumbClass: "breadcrumb-style1",
            rotate: 0,
            indeterminate: false,
            contact_tab_name: "Contact Details",
            items: [
                {
                    icon: "mdi-account-circle-outline",
                    tabname: "1.Student Details",
                    component: "comp-profile",
                },
                {
                    icon: "mdi-account-group-outline",
                    tabname: "2.Parent Details",
                    component: "comp-family-details",
                },
                {
                    icon: "mdi-phone-classic",
                    tabname: "3.Contact Details",
                    component: "comp-contact",
                },
                {
                    icon: "mdi mdi-home",
                    tabname: "4.Address Details",
                    component: "comp-address-details",
                },

                {
                    icon: "mdi-school",
                    tabname: "5.Previous School Attended",
                    component: "comp-last-school-attended",
                },
                {
                    icon: "mdi-cloud-upload-outline",
                    tabname: "6.Upload Documents",
                    component: "comp-upload-documents",
                },
                // {
                //     icon: "mdi-download",
                //     tabname: "View Form",
                //     component: "comp-view-form",
                // },
            ],
            items_desschool_allotment: [
                {
                    icon: "mdi-account-circle-outline",
                    tabname: "1.Student Details",
                    component: "comp-profile",
                },
                {
                    icon: "mdi-account-group-outline",
                    tabname: "2.Parent Details",
                    component: "comp-family-details",
                },
                {
                    icon: "mdi-phone-classic",
                    tabname: "3.Contact Details",
                    component: "comp-contact",
                },
                {
                    icon: "mdi mdi-home",
                    tabname: "4.Address Details",
                    component: "comp-address-details",
                },

                {
                    icon: "mdi-school",
                    tabname: "5.Previous School Attended",
                    component: "comp-last-school-attended",
                },
                {
                    icon: "mdi-cloud-upload-outline",
                    tabname: "6.Upload Documents",
                    component: "comp-upload-documents",
                },
                {
                    icon: "mdi-book",
                    tabname: "7.Subject Registration",
                    component: "subject-registration-details-desschool",
                },
                // {
                //     icon: "mdi-download",
                //     tabname: "View Form",
                //     component: "comp-view-form",
                // },
            ],
            items_sbpps: [
                {
                    icon: "mdi-account-circle-outline",
                    tabname: "1.Student Details",
                    component: "comp-profile",
                },
                {
                    icon: "mdi-account-group-outline",
                    tabname: "2.Parent Details",
                    component: "comp-family-details-sbpps",
                },
                {
                    icon: "mdi-phone-classic",
                    tabname: "3.Guardian Details",
                    component: "comp-contact-details-sbpps",
                },
                {
                    icon: "mdi mdi-home",
                    tabname: "4.Address Details",
                    component: "comp-address-details-sbpps",
                },
                {
                    icon: "mdi-school",
                    tabname: "5.Previous School Attended",
                    component: "comp-last-school-attended",
                },
                {
                    icon: "mdi-stethoscope",
                    tabname: "6.Medical Details",
                    component: "comp-stud-medical-details",
                },
                {
                    icon: "mdi-bus",
                    tabname: "7.Transport Details",
                    component: "comp-stud-transport-details",
                },
                {
                    icon: "mdi-food",
                    tabname: "8.Canteen Details",
                    component: "comp-stud-canteen-details",
                },
                {
                    icon: "mdi-book",
                    tabname: "9.Subject Registration",
                    component: "subject-registration-details-sbpps",
                },
                {
                    icon: "mdi-cloud-upload-outline",
                    tabname: "10.Upload Documents",
                    component: "comp-upload-documents",
                },

            ],
            items_sanjivani: [
                {
                    icon: "mdi-account-circle-outline",
                    tabname: "1.Student Details",
                    component: "comp-profile",
                },
                {
                    icon: "mdi-account-group-outline",
                    tabname: "2.Parent Details",
                    component: "comp-family-details",
                },
                {
                    icon: "mdi-phone-classic",
                    tabname: "3.Contact Details",
                    component: "comp-contact",
                },
                {
                    icon: "mdi mdi-home",
                    tabname: "4.Address Details",
                    component: "comp-address-details",
                },
                {
                    icon: "mdi-school",
                    tabname: "5.Previous School Attended",
                    component: "comp-last-school-attended",
                },
                {
                    icon: "mdi-stethoscope",
                    tabname: "6.Medical Details",
                    component: "comp-stud-medical-details",
                },
                {
                    icon: "mdi-bus",
                    tabname: "7.Transport Details",
                    component: "comp-stud-transport-details",
                },
                {
                    icon: "mdi-cloud-upload-outline",
                    tabname: "8.Upload Documents",
                    component: "comp-upload-documents",
                },
                {
                    icon: "mdi-book",
                    tabname: "9.Subject Registration",
                    component: "subject-registration-details",
                },
            ],
            items_zeal: [
                {
                    icon: "mdi-account-circle-outline",
                    tabname: "1.Student Details",
                    component: "comp-profile",
                },
                {
                    icon: "mdi-account-group-outline",
                    tabname: "2.Parent Details",
                    component: "comp-family-details",
                },
                {
                    icon: "mdi-phone-classic",
                    tabname: "3.Contact Details",
                    component: "comp-contact",
                },
                {
                    icon: "mdi mdi-home",
                    tabname: "4.Address Details",
                    component: "comp-address-details",
                },

                {
                    icon: "mdi-school",
                    tabname: "5.Previous School Attended",
                    component: "comp-last-school-attended",
                },
                {
                    icon: "mdi-bus",
                    tabname: "6.Transport Details",
                    component: "comp-stud-transport-details",
                },
                {
                    icon: "mdi-cloud-upload-outline",
                    tabname: "7.Upload Documents",
                    component: "comp-upload-documents",
                }
            ],
            reload_comp: false,
            form_progress: 0,
            enable_submit: false,
            show_only_view_form_list: [],
            admission_form_no: "",
            admission_form_id: "",
            app_form_fee_master: null,
            application_form_requied:[],
            user_type: null,
            admission_instruction: null,
            admission_instruction_pdf: null,
            to_show: "", //Show-Form or Form-List
            form_list: null,
            admission_personal_email: '',
            admission_personal_contact_number: null,
            admission_personal_email_dialog: false,
            admission_secondary_email_dialog: false,
            loadingforgenerateonlysecondaryemail: false,
              application_form_requied_dialog: false,
            admission_secondary_email: '',
            generate_only_secondary_email: '',
            id:'',
            comp_load: "",
            search: "",
            search1: "",
            dialog: false, //admission instructions
            dialog_pay_fee: false,
            org_id: null,
            defaultValues: null,
            is_receipt_generated: null,
            headers: [
                { text: "# Form", value: "display_admission_form_no", show: true },
                { text: "Application date", value: "application_date", show: true },
                { text: "Status", value: "applicationstatus", show: true },
                { text: "Standard", value: "standard", show: true },
                { text: "Name", value: "fullname", show: true },

                { text: "Edit Application Form", value: "action", sortable: false, show: true },
                {
                    text: "Pay Form Fees",
                    value: "can_pay_form_fees",
                    sortable: false,
                    show: true,
                },
                { text: "View Form", value: "view", sortable: false, show: true },
                { text: "Pay Admission Fee", value: "pay_fee", sortable: false, show: true },
                {
                    text: "Pay Elective Fees",
                    value: "can_pay_elective_fees",
                    sortable: false,
                    show: true,
                },
                { text: "Secondary Email", value: "secondary_email", show: true },
            ],
              requied_headers: [
                { text: "Sr.NO", value: "count", show: true },
                { text: "Field", value: "name", show: true },
             
            ],
            emailRules: [
                v => !!v || 'Email is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
            ],
            mobileRules: [
                v => !!v || 'Mobile number is required',
                v => /^\d{10}$/.test(v) || 'Mobile number must be 10 digits'
            ],
            admission_quota_list: [],
            headers_quota: [
                { text: "Sr No", value: "srno" },
                { text: "Standard", value: "standard" },
                { text: "Academic Year", value: "academicyear" },
                // { text: "Fees", value: "fee" },
                { text: "No Of Forms Allowed", value: "count" },
                { text: "Balance", value: "balance" },
            ],
            show_form_headers: [
                { text: "Sr No", value: "srno", align: "start" },
                { text: "Form No", value: "admission_form_no" },
                { text: "Full Name", value: "fullname" },
                { text: "Action", value: "admission_form_id", sortable: false },
            ],
            qrConfig: {
                is_application_payment_via_qr: false,
                qrCode: "",
                instructions: "",
            },
            payFormFeesByQRDialog: false,
            allotmentApplicable: false,
            Subject_Registration_Tab: false,
        };
    },
    created() {
        this.tenant = localStorage.getItem("EPS-tenant");
        this.standardName = localStorage.getItem("standardName");
    },
    methods: {
        openDialog() {
            if (this.usertype === 'Parent') {
                this.admission_personal_email = this.uid;
                this.admission_personal_contact_number = this.uid;

                this.loadNewForm(); // ✅ You missed this line
            } else {

                this.admission_personal_email_dialog = true;
                this.admission_personal_email == '';
                this.admission_personal_contact_number == null;
            }

        },
        payElectiveFees(){
              let routeData = this.$router.resolve({
                    name: "preference-form",
                    });
                    window.open(routeData.href, "_blank");
        },
        open_secondary_email_dialog(item) {
            alert
            this.id = item.admission_form_id;
            this.admission_secondary_email_dialog = true;
        },
        checkAndSavePersonalEmail() {
            if (this.usertype === "Parent") {
                this.admission_personal_email = this.uid;
                this.admission_personal_contact_number = this.uid;
                this.admission_personal_email_dialog = false;
                this.loadNewForm(); // ✅ You missed this line
            } else {
                if(this.tenant == 'desschool'){
                    const mobilePattern = /^\d{10}$/;

                    if (!mobilePattern.test(this.admission_personal_contact_number)) {
                        this.showSnackbar("error", "Please Enter a Valid Contact Number...!");
                        this.admission_personal_contact_number = null;
                        return;
                    }

                    if (this.admission_personal_contact_number == null || this.admission_personal_contact_number.trim() === '') {
                        this.showSnackbar("red", "Please Enter Contact Number..!");
                    } else {
                        this.admission_personal_email_dialog = false;
                        this.loadNewForm();
                    }
                }else{
                    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                    if (!emailPattern.test(this.admission_personal_email)) {
                        this.showSnackbar("error", "Please Enter a Valid Email...!");
                        this.admission_personal_email = null;
                        return;
                    }
                    // if (!emailPattern.test(this.admission_secondary_email)) {
                    //     this.showSnackbar("error", "Please Enter a Valid Secondary Email...!");
                    //     this.admission_secondary_email = null;
                    //     return;
                    // }

                    if (this.admission_personal_email == null || this.admission_personal_email.trim() === '') {
                        this.showSnackbar("red", "Please Enter Email..!");
                    } else {
                        this.admission_personal_email_dialog = false;
                        this.loadNewForm();
                    }
                }
            }
        },
        fetchForm() {
            if (this.Hide_Application_Form_For_Parents == true)
                this.getViewByAY();
            else
                this.getFormsByAY();

        },

        getViewByAY() {
            this.show_only_view_form_list = [];

            const data = {
                ay: this.acay,
            };

            localStorage.setItem("admission-ay", this.acay);

            axios
                .post("/admissionForm/getApplicationFormForViewByAY", data)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.show_only_view_form_list = res.data.learner_data;
                    }
                })
                .catch((error) => {
                    console.error("Error fetching application forms:", error);
                });
        },
        refreshStandard(newStandard) {
            localStorage.setItem("standardName", newStandard); // Update standard
            this.$forceUpdate(); // Force reactivity
            this.standardName = localStorage.getItem("standardName")
            this.filteredTabs
        },
        viewReceipt(item) {
            this.$store.commit("setform_fees_trans_id", item.transaction_id);
            this.$router.push({ name: "form-fees-receipt" });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getFormsByAY() {
            var loaddiv = "";
            this.form_list = [];
            this.admission_quota_list = [];
            const data = {
                acay: this.acay,
            };

            localStorage.setItem("admission-ay", this.acay);
            axios
                .post("/admissionForm/getApplicationFormByAY", data)
                .then((res) => {
                    // console.log("applicationform",res.data)
                    if (res.data.msg == "200") {
                        this.cay = res.data.cay;
                        this.enable_submit = res.data.enable_submit;
                        this.admission_instruction_pdf = null;
                        this.Hide_Application_Form_If_Receipt_Not_Generated = res.data.Hide_Application_Form_If_Receipt_Not_Generated;
                        this.qrConfig = res.data.qrConfig;
                        if (res.data.admission_instruction != null)
                            this.admission_instruction_pdf =
                                res.data.admission_instruction.documentpath == null ? null : localStorage.getItem("awspath") + res.data.admission_instruction.documentpath + res.data.admission_instruction.documentname;
                        this.admission_instruction = res.data.admission_instruction; // == null ? null : localStorage.getItem("awspath") + res.data.admission_instruction.documentpath + res.data.admission_instruction.documentname;
                        //console.log("applicationform",this.admission_instruction)
                        loaddiv = res.data.to_show;
                        //form fees
                        this.app_form_fee_master = res.data.app_form_fee_master;
                        this.user_type = res.data.user_type;
                         this.application_form_requied = res.data.application_form_requied;
                        this.hide_component = res.data.hide_component;
                        localStorage.setItem("hide_component",this.hide_component)
                        //ends

                        if (loaddiv == "Show-Form") {
                            if (this.usertype === 'Parent') {
                                this.admission_personal_email = this.uid;
                                this.loadNewForm(); // ✅ You missed this line
                            } else {
                                this.admission_personal_email_dialog = true;
                            }

                        } else if (loaddiv == "Form-List") {
                            this.form_list = res.data.form_list;
                            let can_pay = this.form_list[0].can_pay_form_fees;
                            let pay_inst = this.form_list[0].pay_inst_fees;
                            let pay_elective_fees = this.form_list[0].can_pay_elective_fees
                            if (this.org_id == 'sbpps') {
                                this.headers[8].show = false;
                            }
                            if (!can_pay) {
                                this.headers[7].show = false;
                            }
                            if (!pay_inst) {
                                this.headers[9].show = false;
                            }
                            if (!pay_elective_fees) {
                                this.headers[9].show = false;
                            }
                            this.reload_comp = true;
                            this.admission_quota_list = res.data.admission_quota_list;
                            this.to_show = loaddiv;
                            //this.defaultValues = res.data.defaultValues
                            //this.is_receipt_generated = res.data.is_receipt_generated
                        } 
                        else {
                            if(res.data.flag == "NA"){
                                this.showSnackbar("red",res.data.snackbar)
                                return
                            }
                            alert("Please try again!!!");
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        payFormFeesPage() {
            this.$router.push({ name: "application-form-fees-parent" });
        },
        payInstFeesPage(form_id) {
            localStorage.setItem("ay", this.acay);
            localStorage.setItem("application_form", form_id);
            this.$router.push({ name: "inst-fees-payment" });
        },
        viewForm(item) {
            // alert(this.admission_form_id)
            // console.log(item);
            // alert(item.admission_form_id)

            if (this.org_id == "sbpps") {
                localStorage.setItem("setay", this.acay);
                if (item == null) {
                    localStorage.setItem("setform_id", this.admission_form_id);
                } else {
                    localStorage.setItem("setform_id", item.admission_form_id);
                }
                let routeData = this.$router.resolve({
                    name: "view-application-form-sbpps",
                });
                window.open(routeData.href, "_blank");
            } else {
                localStorage.setItem("admission-ay", this.acay);
                if (item == null) {
                    localStorage.setItem("admission_form_no", this.admission_form_id);
                } else {
                    localStorage.setItem("admission_form_no", item.admission_form_id);
                }
                let routeData = this.$router.resolve({ name: "parent-view-form" });
                window.open(routeData.href, "_blank");
            }
        },
           viewrequiredfields() {
           this.application_form_requied_dialog=true;
        },
        toProcressApplication() {
            const application_form_data = {
                admission_form_no: this.admission_form_no,
                admission_form_id: this.admission_form_id,
            };
            (this.overlay = true),
                axios
                    .post("/admissionForm/submitApplication", application_form_data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.form_saved == "YES") {
                                this.showSnackbar("green", "Submitted Successfully...");
                                this.overlay = false;
                                this.getFormsByAY();
                            }
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        "use strict";
                        var overlay = false;
                    });
        },
        saveOnlySecondaryEmail() {
                 if (!confirm("Are You Sure You Want to Add Secondary Email?")) return;
            this.loadingforgenerateonlysecondaryemail=true;
            const application_form_data = {
                id: this.id,
                generate_only_secondary_email: this.generate_only_secondary_email,
            };
           
                axios
                    .post("/admissionForm/generateSecondaryEmail", application_form_data)
                    .then((res) => {
                       
                            if (res.data.flag == "YES") {
                                this.showSnackbar("green", "Generate Secondary Email Successfully...");
                               
                                this.loadingforgenerateonlysecondaryemail=false;
                                 this.admission_secondary_email_dialog = false;
                                  this.getFormsByAY();
                            }else if(res.data.flag=="NO"){
                                 this.showSnackbar("red", res.data.msg);
                                  this.loadingforgenerateonlysecondaryemail=false;
                            }
                       
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        "use strict";
                        var overlay = false;
                    });
        },
        submitApplication() {

            //return
            if (this.user_type == "Parent") {
                if (this.admission_instruction != null) {
                    //window.open(this.admission_instruction);
                    if (!confirm("Have you read the admission form instruction and want to submit the form, press OK.")) return;
                    // if (!confirm("Have you read the admission form instruction and want to submit the form, press OK...Please remember your form number")) return;
                }
            }
            // alert("done")
            // this.toProcressApplication();
            if (this.app_form_fee_master == null) {
                this.toProcressApplication();
                return;
            } else {
                if (this.user_type == "Parent") {
                    // alert("in paent---")
                    // return
                    if (this.org_id == "sbpps") {
                        // alert("in sbpps alert---")
                        this.toProcressApplication();
                        this.$router.push({ name: "application-form-fees-parent" });
                    } else {
                        this.toProcressApplication();
                    }
                    return;
                } else this.$router.push({ name: "application-form-fees-staff" });
            }
        },
        loadComponent(comp_id) {
            this.comp_load = comp_id;
        },
        loadForm(formData) {
            this.standardName = ""
            localStorage.setItem("standardName", "")
            if (formData.standard) {
                this.standardName = formData.standard
            } else {
                this.standardName = localStorage.getItem("standardName")
            }
            //alert(this.standardName)
            if (formData.applicationstatus != "Initiated") {
                alert("Cannot Edit Form Once Submitted!!!");
                return;
            }
            this.admission_form_no = formData.admission_form_no;
            this.display_admission_form_no = formData.display_admission_form_no;
            this.admission_form_id = formData.admission_form_id;
            const application_form_data = {
                admission_form_no: this.admission_form_no,
                admission_form_id: this.admission_form_id,
                display_admission_form_no: this.display_admission_form_no,
            };
            this.$store.commit("getformdata", application_form_data);
            this.to_show = "Show-Form";
            //alert(formData)
        },
        init_or_reload() {
            this.form_list = [];
            var loaddiv = "";
            axios
                .post("/admissionForm/applicationform")
                .then((res) => {
                    // console.log("applicationform",res.data)
                    if (res.data.msg == "200") {
                        this.ay_list = res.data.ay_list;
                        this.Hide_Application_Form_For_Parents = res.data.Hide_Application_Form_For_Parents;
                        this.allotmentApplicable = res.data.allotmentApplicable;
                        this.Subject_Registration_Tab = res.data.Subject_Registration_Tab;
                        

                        //  if (loaddiv == "Show-Form") {
                        //   this.loadNewForm();
                        // } else if (loaddiv == "Form-List") {
                        //   this.form_list = res.data.form_list;
                        //   let can_pay = this.form_list[0].can_pay_form_fees;
                        //   // console.log("in form list::::", can_pay);
                        //   if (!can_pay) {
                        //     // console.log("in if func");
                        //     // console.log("headers::", this.headers[7].show);
                        //     this.headers[7].show = false;
                        //   }
                        //   this.reload_comp = true;
                        //   this.to_show = loaddiv;
                        // }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        loadNewForm() {

            if (!confirm("This will generate new form. Click 'OK' to continue.Please remember your form number!!!")) {
                return;
            }
            const data = {
                admission_personal_email: this.admission_personal_email,
                admission_personal_contact: this.admission_personal_contact_number,
                admission_secondary_email: this.admission_secondary_email

            }
            axios
                .post("/admissionForm/details", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.comp_load = "comp-profile";
                        this.loadForm(res.data.form_data);
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        alert("Something went wrong!!!");
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
    },
    mounted() {
        this.usertype = localStorage.getItem("EPS-ut");
        if (this.usertype === "Parent") {
            this.uid = localStorage.getItem("EPS-uid")
            this.admission_personal_email = this.uid
            this.admission_personal_contact_number = this.uid
        }


        this.$store.commit("setform_progress", 0);
        this.form_progress = this.$store.getters.form_progress;
        this.init_or_reload();
        this.org_id = localStorage.getItem("EPS-tenant");
    },
    watch: {
        "$store.state.form_progress": function () {
            this.form_progress = this.$store.getters.form_progress;
        },
        standardName(newStandard) {
            //alert("hiii"+newStandard)
            this.$forceUpdate(); // Force tab update
        }
    },
    computed: {
        // standardName() {
        //     alert("hiii")
        //     return localStorage.getItem("standardName") || ""; // Fetch from localStorage
        // },
        _headers() {
            return this.headers.filter((x) => x.show);
        },
        // filteredTabs() {
        //     // Define the standards that should show "10. Subject Registration"
        //     const allowedStandards = ["XI (Comm)", "XI (Sci)", "XII (Comm)", "XII (Sci)",'I'];
        //     return this.items_sbpps.filter(item => {
        //         if (item.tabname === "9.Subject Registration") {
        //         //return allowedStandards.includes(this.standardName);
        //         return this.standardName && allowedStandards.includes(this.standardName);
        //         }
        //         return true;
        //     });
        // },
        // filteredTabs() {
        //     // Define the standards that should show "9. Subject Registration"
        //     //const allowedStandards = ["XI (Comm)", "XI (Sci)", "XII (Comm)", "XII (Sci)","I"];
        //     const allowedStandards = ["XI (Comm)", "XI (Sci)", "XII (Comm)", "XII (Sci)"];

        //     // Filter out "9. Subject Registration" if the standardName is empty or not in the allowed list
        //     let filteredTabs = this.items_sbpps.filter(item => {
        //         if (item.tabname === "9.Subject Registration") {
        //             return this.standardName && allowedStandards.includes(this.standardName);
        //         }
        //         return true;
        //     });

        //     // Find the index of "10. Upload Documents" and update its tab number if necessary
        //     const uploadDocumentsIndex = filteredTabs.findIndex(item => item.tabname === "10.Upload Documents");

        //     if (uploadDocumentsIndex !== -1) {
        //         const subjectRegistrationExists = filteredTabs.some(item => item.tabname === "9.Subject Registration");

        //         // If "9.Subject Registration" is removed, update "10.Upload Documents" to "9.Upload Documents"
        //         if (!subjectRegistrationExists) {
        //             filteredTabs[uploadDocumentsIndex] = {
        //                 ...filteredTabs[uploadDocumentsIndex],
        //                 tabname: "9.Upload Documents"
        //             };
        //         }
        //     }

        //     return filteredTabs;
        //             }
        // },

        filteredTabs() {
            //alert("filteredTabs"+this.standardName)
            const allowedStandards = ["XI (Comm)", "XI (Sci)", "XII (Comm)", "XII (Sci)", "XI (Humanities)"];

            // Filter out "9.Subject Registration" if standard is not in the allowed list
            let filteredTabs = this.items_sbpps.filter(item => {
                if (item.tabname === "9.Subject Registration") {
                    return this.standardName && allowedStandards.includes(this.standardName);
                }
                return true;
            });

            // Adjust numbering for "10.Upload Documents" if needed
            const uploadDocumentsIndex = filteredTabs.findIndex(item => item.tabname === "10.Upload Documents");
            if (uploadDocumentsIndex !== -1) {
                const subjectRegistrationExists = filteredTabs.some(item => item.tabname === "9.Subject Registration");

                if (!subjectRegistrationExists) {
                    filteredTabs[uploadDocumentsIndex] = {
                        ...filteredTabs[uploadDocumentsIndex],
                        tabname: "9.Upload Documents"
                    };
                }
            }
            return filteredTabs;
        }
    }
};
</script>
<style scoped>
.flash {
    animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {
        color: red;
    }

    to {
        color: white;
    }
}

h2 {
    color: #333333;
}

.admission-color {
    background-color: #fff;
}

.active-class {
    color: #3f51b5;
}

.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.admission-inst-div {
    position: absolute;
    right: 40px;
    top: 7%;
}

.admission-inst {
    text-decoration: none;
    border: 1px solid #4caf50;
    padding: 4px 6px;
    color: #4caf50;
    transition-delay: 0.1s;
    transition-duration: 0.3s;
}

.admission-inst:hover {
    background-color: #4caf50;
    border-color: #4caf50;
    color: white;
}

.admission-inst .v-icon.v-icon {
    color: #4caf50;
}

.admission-inst:hover .v-icon.v-icon {
    color: white;
}

.blink_me {
    animation: blinker 1s linear infinite;
}

@keyframes blinker {
    50% {
        opacity: 0;
    }
}

.active {
    color: #222222;
    background-color: #ffff;
}

@media (max-width: 700px) {
    body {
        overflow-x: hidden;
        width: 100%;
    }

    .footer-btn {
        text-transform: none;
        font-size: 12px !important;
        display: block !important;
        word-wrap: break-word;
        width: 50%;
    }

    .add-form {
        margin-top: 5px;
        font-size: 12px;
        word-wrap: break-word;
    }

    .mob-toolbar {
        height: 90px !important;
    }

    .back-form {
        white-space: normal;
    }
}

.ay-main {
    font-size: 21px;
}
.custom-tabs .v-tab {
    color: white !important;
}

.custom-tabs .v-tab .v-icon {
    color: white !important;
}

.custom-tabs .v-tab.active-tab {
    color: black !important;
    background-color: #ffff;
}

.custom-tabs .v-tab.active-tab .v-icon {
    color: black !important;
    background-color: #ffff;
}
</style>
